import React, {useEffect} from 'react'
import { useState } from 'react';
import ZadajBezplatnePytanie from './ZadajBezplatnePytanie'

function WKZapytajPrawnika() {
    const [uuid, setUUID] = useState('');
    const default_category = window.location.pathname.split('/')[3];

    let _csrfToken = null;

    async function getCsrfToken() {
      if (_csrfToken === null) {
        const response = await fetch('/api/csrftoken/', {
          credentials: 'include',
        });
        const data = await response.json();
        _csrfToken = data.csrftoken;
      }
      return _csrfToken;
    }

    useEffect(() => {
        async function fetchData() {
            fetch('/api/analytics/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "X-CSRFToken": await getCsrfToken()
                },
                body: JSON.stringify({
                    referer: document.referrer,
                    banner_type: 1,
                    category: default_category
                })

            }).then(res => res.json().then(data => {
                setUUID(data.uuid)
            }))
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  return (
    <ZadajBezplatnePytanie if_WK={true} default_category={default_category} uuid={uuid}/>
  )
}

export default WKZapytajPrawnika